import { createAction } from 'redux-act';
import axios from 'axios';

/**
 * Create the action
 */

const request = createAction('REQUEST_PORTFOLIO_EXPORT_REQUEST');
const success = createAction('REQUEST_PORTFOLIO_EXPORT_SUCCESS');
const error = createAction('REQUEST_PORTFOLIO_EXPORT_ERROR');

function getAssessedEvidence(requestData) {
  return async function (dispatch, getState) {
    // Create default request
    const config = {
      headers: {
        Accept: 'application/json',
      },
      baseURL: '/api/',
    };

    // Retrieve token
    const { token } = getState().authentication;

    // Check if we need to do token stuff
    if (token) {
      // Add token to header
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token?.access_token}`,
      };
    }

    const fetch = axios.create(config);
    const response = await fetch.post('portfolio/request-export', requestData);
    return response.data;
  };
}

/**
 * Export the components
 */

export { getAssessedEvidence as default };
export { request, success, error };
